import angular from 'angular'

/**
 * The core service used by angular apps to set their own locale settings when using the filter. This service
 * attempts to make the agnostic to what the apps locale data might look like and allows each app to override the
 * settings to what is required for their use.
 *
 * @module vend.ui.vdCurrencySettings
 */
angular.module('vend.ui').service('vdCurrencySettings', function () {
  this.settings = {}

  /**
   * Set the settings
   *
   * @method vdCurrencySettings.update
   * @param  newSettings {Object}
   *         The settings that should be used by the filter.
   *
   * @return {Object} The new settings to be used by the filter.
   */
  this.update = newSettings => {
    angular.extend(this.settings, newSettings)
  }
})
